import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
// -
import {SwalAlertClass} from "core/swalClass";
import FormTabProgramming from "./FormTabProgramming";
import {updateListById} from "core/utils/arrays";
import axiApi from "ApiCaller";
import FormButton from "components/buttons/FormButton";

const FormProgramming = ({
    item,
    setItem,
    items,
    showForm,
    setShowForm,
    setItemsShow,
    fetchProgrammings,
}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: tR} = useTranslation("routes");

    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const [keyTab, setKeyTab] = useState("programming");
    const [optionsShown, setOptionsShown] = useState([]);
    const [option, setOption] = useState("0");
    const inputRefs = useRef({
        name: null,
        date_start: null,
        hour_start: null,
    });
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setOption("0");
        setOptionsShown([]);
    }, [item]);

    const handleClose = () => setShowForm(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setKeyTab("programming");
        if (!item.name) {
            Alert.warning("Falta dato obligatorio", "Es necesario un Nombre").then(
                () => {
                    inputRefs.current.name.focus();
                },
            );
            return;
        } else if (!item.date_start) {
            Alert.warning("Falta dato obligatorio", "Es necesario la Fecha de inicio");
            return;
        }
        setIsLoading(true);
        let dataSend = {...item};
        // eliminar segundos de TIME
        if (dataSend.run.includes(":")) {
            dataSend.run = dataSend.run.split(":").slice(0, 2).join(":");
        }
        if (Array.isArray(dataSend.email_recipients)) {
            if (
                dataSend.email_recipients.length > 0 &&
                typeof dataSend.email_recipients[0] === "object"
            ) {
                dataSend.email_recipients = dataSend.email_recipients.map(
                    (obj) => obj.value,
                );
            }
        } else if (typeof dataSend.email_recipients === "string") {
            dataSend.email_recipients = dataSend.email_recipients
                .split("\n")
                .map((email) => email.trim())
                .filter((email) => email.length > 0);
        } else {
            dataSend.email_recipients = [];
        }
        axiApi
            .post(`/api/reports/programing/`, dataSend)
            .then((resp) => {
                if (resp.data.status) {
                    items.current.clearChosen();
                    if (dataSend.id) {
                        items.current.showed = updateListById(
                            items.current.showed,
                            resp.data.item,
                        );
                    } else {
                        items.current.showed.push(resp.data.item);
                    }

                    setItemsShow([...items.current.showed]);
                    setShowForm(false);
                    Alert.success(_Tf("labels.success"), _Tf("success.title"));
                    fetchProgrammings();
                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <>
            <Offcanvas
                show={showForm}
                onHide={handleClose}
                placement="end"
                backdrop="static"
                style={{width: "80%", fontSize: "15px"}}>
                <Offcanvas.Header className="preview-canvas">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="clipboard" />
                    </div>
                    <div className="preview-title">
                        <Offcanvas.Title>{tR("labels.programming")}</Offcanvas.Title>
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body className="pt-0" style={{fontSize: "13px"}}>
                    <div className="col-12">
                        <Tabs
                            activeKey={keyTab}
                            id="form-programming-tabs"
                            onSelect={(k) => setKeyTab(k)}
                            className="mb-3 mt-1"
                            justify>
                            <Tab
                                eventKey="programming"
                                title={tR("labels.programming")}>
                                <FormTabProgramming
                                    item={item}
                                    setItem={setItem}
                                    optionsShown={optionsShown}
                                    setOptionsShown={setOptionsShown}
                                    option={option}
                                    setOption={setOption}
                                    inputRefs={inputRefs}
                                />
                            </Tab>
                        </Tabs>
                    </div>
                    <div className="p-3 buttons-footer">
                        <div className="position-fixed bottom-0 end-0 mb-3 me-5">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={handleClose}>
                                {_Tf("labels.cancel")}
                            </button>
                            <FormButton
                                label="Guardar"
                                className="btn btn-primary ms-4"
                                isProcessing={isLoading}
                                onClick={handleSubmit}>
                                {_Tf("labels.save")}
                            </FormButton>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default FormProgramming;
